export const CARD_SIZES = {
  'featured-hero': {
    showLabel: true,
    imageSize: 'xlarge'
  },
  'featured-secondary': {
    showLabel: false,
    imageSize: 'large'
  },
  'featured-block': {
    showLabel: true,
    imageSize: 'large'
  },
  'event-large': {
    showLabel: false,
    imageSize: 'large'
  },
  'event-med': {
    showLabel: false,
    imageSize: 'medium'
  },
  'event-small': {
    showLabel: false,
    imageSize: 'medium'
  },
  'event-tiny': {
    showLabel: false,
    imageSize: 'small'
  },
  'editorial-left': {
    showLabel: true,
    imageSize: 'large'
  },
  'editorial-left-fail': {
    showLabel: false,
    imageSize: 'large'
  },
  'editorial-right': {
    showLabel: true,
    imageSize: 'large'
  },
  'editorial-right-fail': {
    showLabel: false,
    imageSize: 'large'
  },
  'editorial-bleed': {
    showLabel: true,
    imageSize: 'large'
  },
  'editorial-large': {
    showLabel: true,
    imageSize: 'large'
  }
}
